import startApp from "../../entry";
// const homePage = () => import("@/pages/homePage.vue");
import digitalPlatformPage from "./digitalPlatformPage.vue";

startApp(digitalPlatformPage);